import { Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import { Tasks } from '../../../_interfaces/tasks.interface';
import { Router } from '@angular/router';
import { CardStatus } from '../../../_interfaces/cards.interface';
interface TaskProperties {
  iconBgColor: string;
  iconColor: string;
  icon: string;
  title: string;
  body: string;
  url?: string;
  queryParams?: { [key: string]: string | number | boolean };
}

@Component({
  selector: 'app-notification-dropdown',
  imports: [NgOptimizedImage],
  providers: [DatePipe],
  templateUrl: './tasks-dropdown.component.html',
})
export class TasksDropdownComponent implements OnInit, OnChanges {
  readonly datePipe = inject(DatePipe);
  readonly router = inject(Router);

  @Input({ required: true }) tasks: Tasks | undefined;
  protected taskProperties: Array<TaskProperties> = [];

  ngOnInit(): void {
    this.setProperties();
  }

  ngOnChanges(): void {
    this.setProperties();
  }

  private setProperties() {
    if (this.tasks == undefined) return;

    this.taskProperties = [];

    if (this.tasks.fund_account.display) {
      const fundAccountDate = this.tasks.fund_account.date;
      const formattedDate = this.datePipe.transform(fundAccountDate, 'd MMM, y');

      this.taskProperties.push({
        iconBgColor: 'bg-info-subtle',
        iconColor: 'text-secondary',
        icon: 'iconoir-arrow-up-circle',
        title: 'Top up required',
        body: `Your subscription billing date is on ${formattedDate}. You currently do not have enough funds to cover the subscription fee.`,
        url: '/fund-account',
      });
    }

    if (this.tasks.link_cards.display) {
      this.taskProperties.push({
        iconBgColor: 'bg-info-subtle',
        iconColor: 'text-secondary',
        icon: 'pays-icon ic-card-linked',
        title: 'Link employee card(s)',
        body: `${this.tasks.link_cards.count} employee card(s) still need to be linked to Apple Pay/Google Pay.`,
        url: '/cards/employee-cards',
      });
    }

    if (this.tasks.capture_receipts.display) {
      this.taskProperties.push({
        iconBgColor: 'bg-danger-subtle',
        iconColor: 'text-danger',
        icon: 'pays-icon ic-receipt',
        title: 'Receipt(s) not captured',
        body: 'Please capture missing receipt(s) from previous transactions.',
        queryParams: { receipt: false },
        url: '/accounting/transactions',
      });
    }

    if (this.tasks.replace_cards.display) {
      this.taskProperties.push({
        iconBgColor: 'bg-danger-subtle',
        iconColor: 'text-danger',
        icon: 'iconoir-credit-card-slash',
        title: 'Card blocked',
        body: `${this.tasks.replace_cards.count} employee card(s) have been blocked. Please replace these card(s) or remove the employee(s).`,
        queryParams: { status: CardStatus.Blocked },
        url: '/cards/employee-cards',
      });
    }
  }

  onTaskClick(task: TaskProperties) {
    if (task.url) {
      this.router.navigate([task.url], { queryParams: task.queryParams || {} });
    }
  }
}
